/* Snugpup SkyNest cart drawer and cart page.
   Quantity changes save on their own, so there's no Update button.
   The stepper stops at 1; the bin button removes the item. */
(function () {
  'use strict';
  if (window.SnugCart) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DRAWER = 'snugpup-cart-drawer';
  var PAGE = 'snugpup-cart-page';
  var DELAY = 350;
  var drawer = document.querySelector('[data-sc-drawer]');
  var panel = drawer ? drawer.querySelector('[data-sc-panel]') : null;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var pending = {};
  var timers = {};
  var inflight = 0;
  var seq = 0;
  var applied = 0;
  var termsOn = false;
  var lastFocus = null;
  var checkoutWaiting = false;
  var noteTimer = null;
  var selfAdd = 0;
  var addTimer = null;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function strings() {
    var t = (window.theme && window.theme.strings) || {};
    return {
      error: 'That didn’t save. Please try again.',
      terms: t.cartTermsConfirmation || 'Please agree to the terms before checking out.'
    };
  }

  function ids() {
    var list = [DRAWER];
    if (document.getElementById('shopify-section-' + PAGE)) list.push(PAGE);
    return list;
  }

  function busy() { return inflight > 0 || Object.keys(timers).length > 0; }

  function paintBusy() {
    var on = busy();
    each(document.querySelectorAll('[data-sc-checkout]'), function (b) {
      b.setAttribute('aria-disabled', on ? 'true' : 'false');
    });
  }

  function count() {
    var body = document.querySelector('#shopify-section-' + DRAWER + ' [data-sc-body]') ||
      document.querySelector('[data-sc-body]');
    var n = body ? parseInt(body.getAttribute('data-sc-count'), 10) : NaN;
    return isNaN(n) ? null : n;
  }

  function paintCount() {
    var n = count();
    if (n === null) return;
    each(document.querySelectorAll('[data-sc-headcount]'), function (el) {
      el.textContent = '(' + n + (n === 1 ? ' item)' : ' items)');
    });
    each(document.querySelectorAll('[data-sp-cartcount]'), function (el) { el.textContent = n; });
    each(document.querySelectorAll('[data-sc-extra]'), function (el) { el.hidden = n === 0; });
  }

  function paintLine(line, qty) {
    var n = line.querySelector('[data-sc-n]');
    var minus = line.querySelector('[data-sc-minus]');
    if (n) n.textContent = qty;
    if (minus) minus.disabled = qty <= 1;
  }

  function linesFor(key) {
    return Array.prototype.filter.call(document.querySelectorAll('[data-sc-line]'), function (l) {
      return l.getAttribute('data-key') === key;
    });
  }

  function reapplyPending() {
    Object.keys(pending).forEach(function (key) {
      linesFor(key).forEach(function (line) { paintLine(line, pending[key]); });
    });
  }

  function restoreFocus(hint) {
    if (!hint || (document.activeElement && document.activeElement !== document.body)) return;
    var sec = document.getElementById('shopify-section-' + hint.section);
    if (!sec) return;
    var el = null;
    var line = null;
    each(sec.querySelectorAll('[data-sc-line]'), function (l) {
      if (!line && l.getAttribute('data-key') === hint.key) line = l;
    });
    if (line) {
      el = line.querySelector(hint.act === 'minus' ? '[data-sc-minus]' : '[data-sc-plus]');
      if (el && el.disabled) el = line.querySelector('[data-sc-plus]');
    }
    if (!el) el = sec.querySelector('[data-sc-line] [data-sc-plus]') || sec.querySelector('.sc-btn') || sec.querySelector('.sc-x');
    if (el && el.focus) el.focus({ preventScroll: true });
  }

  function swap(sections, hint) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      var live = document.querySelector('#shopify-section-' + id + ' [data-sc-body]');
      if (!html || !live) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sc-body]');
      if (!fresh) return;
      live.className = fresh.className;
      live.setAttribute('data-sc-count', fresh.getAttribute('data-sc-count') || '0');
      live.innerHTML = fresh.innerHTML;
    });
    each(document.querySelectorAll('[data-sc-terms]'), function (c) { c.checked = termsOn; });
    reapplyPending();
    paintCount();
    paintBusy();
    restoreFocus(hint);
  }

  function showMsg(text) {
    each(document.querySelectorAll('[data-sc-msg]'), function (b) { b.textContent = text || ''; });
  }

  function settle() {
    paintBusy();
    if (!busy() && checkoutWaiting) {
      checkoutWaiting = false;
      window.location.href = ROOT + 'checkout';
    }
  }

  function post(url, body) {
    inflight++;
    paintBusy();
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var e = new Error(j.description || j.message || '');
          e.shopify = true;
          throw e;
        }
        return j;
      });
    }).finally(function () {
      inflight--;
      settle();
    });
  }

  function refresh(hint) {
    var mine = ++seq;
    return fetch(ROOT + '?sections=' + ids().join(','), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      return r.ok ? r.json() : null;
    }).then(function (sections) {
      if (sections && mine >= applied) {
        applied = mine;
        swap(sections, hint);
      }
    }).catch(function () {});
  }

  function change(key, qty, hint) {
    var mine = ++seq;
    showMsg('');
    linesFor(key).forEach(function (l) { l.classList.add('is-busy'); });
    return post(ROOT + 'cart/change.js', {
      id: key,
      quantity: qty,
      sections: ids().join(','),
      sections_url: window.location.pathname
    }).then(function (cart) {
      if (mine >= applied) {
        applied = mine;
        swap(cart.sections, hint);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function (err) {
      return refresh(hint).then(function () {
        showMsg(err && err.shopify && err.message ? err.message : strings().error);
      });
    });
  }

  function queue(key, qty, hint) {
    pending[key] = qty;
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () {
      delete timers[key];
      var q = pending[key];
      delete pending[key];
      change(key, q, hint);
    }, DELAY);
    paintBusy();
  }

  function flush() {
    Object.keys(timers).forEach(function (key) {
      clearTimeout(timers[key]);
      delete timers[key];
      var q = pending[key];
      delete pending[key];
      change(key, q);
    });
    paintBusy();
  }

  function open() {
    if (!drawer) { window.location.href = ROOT + 'cart'; return; }
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('sc-lock');
    setTimeout(function () {
      var x = drawer.querySelector('.sc-x') || panel;
      if (x && x.focus) x.focus({ preventScroll: true });
    }, reduce ? 0 : 60);
  }

  function close() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('sc-lock');
    setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, reduce ? 0 : 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* The header cart icon opens this drawer. Registered on window in the capture phase so it runs
     before other cart-drawer apps that also listen for clicks on cart links. */
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!drawer || !t || !t.closest) return;
    var icon = t.closest('[data-sp-carticon]');
    if (!icon || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
    refresh();
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-sc-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var btn = t.closest('[data-sc-minus],[data-sc-plus],[data-sc-remove]');
    if (!btn) return;
    var line = btn.closest('[data-sc-line]');
    if (!line) return;
    e.preventDefault();

    var key = line.getAttribute('data-key');
    var sec = line.closest('.shopify-section');
    var hint = { section: sec ? sec.id.replace('shopify-section-', '') : DRAWER, key: key };
    var current = Object.prototype.hasOwnProperty.call(pending, key) ? pending[key] : (parseInt(line.getAttribute('data-qty'), 10) || 1);

    if (btn.hasAttribute('data-sc-remove')) {
      clearTimeout(timers[key]);
      delete timers[key];
      delete pending[key];
      hint.act = 'remove';
      change(key, 0, hint);
      return;
    }

    if (btn.disabled) return;
    var plus = btn.hasAttribute('data-sc-plus');
    var next = plus ? current + 1 : Math.max(1, current - 1);
    if (next === current) return;
    hint.act = plus ? 'plus' : 'minus';
    linesFor(key).forEach(function (l) { paintLine(l, next); });
    queue(key, next, hint);
  });

  document.addEventListener('keydown', function (e) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab' || !panel) return;
    var f = Array.prototype.filter.call(
      panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea,select,[tabindex]'),
      function (el) { return el.tabIndex !== -1 && el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-sc-terms]')) termsOn = t.checked;
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-sc-note]')) return;
    clearTimeout(noteTimer);
    var v = t.value;
    noteTimer = setTimeout(function () {
      post(ROOT + 'cart/update.js', { note: v }).catch(function () {});
    }, 500);
  });

  /* Checkout, and every other add-to-cart form on the site. Runs after each form's own
     handlers: anything that already handled its submit (preventDefault) is left alone. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || e.defaultPrevented) return;

    if (form.hasAttribute('data-sc-checkout-form')) {
      var terms = form.querySelector('[data-sc-terms]');
      if (terms && !terms.checked) {
        e.preventDefault();
        showMsg(strings().terms);
        terms.focus();
        return;
      }
      if (busy()) {
        e.preventDefault();
        checkoutWaiting = true;
        flush();
        settle();
      }
      return;
    }

    var action = form.getAttribute('action') || '';
    if (!drawer || action.indexOf('/cart/add') === -1 || form.hasAttribute('data-sc-native')) return;
    e.preventDefault();
    var submitter = e.submitter || form.querySelector('[type="submit"]');
    if (submitter) submitter.setAttribute('aria-busy', 'true');
    selfAdd++;
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var er = new Error(j.description || j.message || '');
          er.shopify = true;
          throw er;
        }
        return j;
      });
    }).then(function () {
      return refresh();
    }).then(function () {
      open();
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }).catch(function (err) {
      return refresh().then(function () {
        open();
        showMsg(err && err.shopify && err.message ? err.message : strings().error);
      });
    }).then(function () {
      selfAdd--;
      if (submitter) submitter.removeAttribute('aria-busy');
    });
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { close(); refresh(); }
  });

  /* The theme's own product forms, quick add and apps add to the cart with AJAX instead of a
     normal form submit. Watch for any successful add and open the drawer afterwards. */
  function isAdd(url, method) {
    return String(method || 'GET').toUpperCase() === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }
  function afterAdd() {
    if (!drawer || selfAdd > 0) return;
    clearTimeout(addTimer);
    addTimer = setTimeout(function () { refresh().then(open); }, 60);
  }
  if (drawer && window.fetch) {
    var baseFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
      var p = baseFetch.apply(this, arguments);
      if (isAdd(url, method)) {
        p.then(function (r) { if (r && r.ok) afterAdd(); }, function () {});
      }
      return p;
    };
  }
  if (drawer && window.XMLHttpRequest) {
    var baseOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isAdd(url, method)) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) afterAdd();
        });
      }
      return baseOpen.apply(this, arguments);
    };
  }

  if (drawer) {
    /* Custom product sections call theme.cart.buildCart() after adding; route that to the drawer. */
    window.theme = window.theme || {};
    window.theme.cart = window.theme.cart || {};
    window.theme.cart.buildCart = function () { return refresh().then(open); };
  }

  window.SnugCart = { open: open, close: close, refresh: refresh, busy: busy };
  paintCount();
})();
